import React, { Suspense, lazy, useRef, useCallback } from "react";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";

const RecordingSpirometry = lazy(() => import("recordingSpirometry/App"));

export default function RecordingSpirometryRouter(props) {
  const navigate = useNavigate();
  const didRedirectRef = useRef(false);

  const handleUploadStatus = useCallback(
    (nextStatus) => {
      props.onUploadStatus?.(nextStatus);

      // Optional: route away from /recording/spirometry/camera once upload begins
      if (nextStatus === "uploading" && !didRedirectRef.current) {
        didRedirectRef.current = true;
        navigate("/recording/spirometry", { replace: true });
      }
    },
    [navigate, props]
  );

  return (
    <Suspense
      fallback={
        <div className="flex h-full w-full items-center justify-center">
          <ClipLoader size={48} />
        </div>
      }
    >
      <RecordingSpirometry
        {...props}
        onUploadStatus={handleUploadStatus}
        onUploadProgress={props.onUploadProgress}
      />
    </Suspense>
  );
}